export { default as AlternatingFeatureBlock } from './FeatureBlocks/AlternatingFeatureBlock';
export { default as TextBasedFeatureBlock } from './FeatureBlocks/TextBasedFeatureBlock';
export { default as SplitGridLogoCloud } from './SplitGridLogoCloud';
export { default as FooterCTA } from './FooterCTA';
export { default as CustomerLogoCloud } from './CustomerLogoCloud';
export { default as VideoHero } from './VideoHero/VideoHero';
export { default as SimpleCenteredHeading } from './SimpleCenteredHeading';
export { CircleThreeColTeam } from './Team';
export { default as ExplainingTheVision } from './ExplainingTheVision';
export { default as FAQs } from './faqs';
export { default as Values } from './Values';
export { default as TestimonialsCloud } from './Testimonials/TestimonialsCloud';
export { default as SidebarTestimonial } from './Testimonials/SidebarTestimonial';
export { default as CenteredHero } from './CenteredHero/CenteredHero';
export { default as HeroForm } from './CenteredHero/HeroForm';
